module.exports = __webpack_public_path__ + "img/no_img.d4917668.svg";